import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import {
  CoachingFormInputData,
  NoCoachReasonsObject,
} from '../../../api/CoachingForm/schema';
import { COACHING_TEXT_LIMIT } from '../../../Util';

const validationSchema = (intl: IntlShape): Yup.ObjectSchema =>
  Yup.object<CoachingFormInputData>().shape({
    reason: Yup.string()
      .nullable()
      .oneOf(
        Object.values(NoCoachReasonsObject),
        intl.formatMessage({
          id: 'cs_perfportal_coaching_nosession_validate_required_reason',
          defaultMessage: 'Please choose a reason from the dropdown',
        })
      ),
    otherReason: Yup.string()
      .max(COACHING_TEXT_LIMIT, '-')
      .when('reason', {
        is: (value: string) => value === 'OTHER',
        then: Yup.string().required(
          intl.formatMessage({
            id: 'cs_perfportal_coaching_nosession_validate_required_other_description',
            defaultMessage: 'Please describe the reason',
          })
        ),
      }),
  });

export default validationSchema;
